import { IconButton, StandardButton } from "../atoms/buttons";
import { ChatInputField } from "./chatInput";
import { icon } from "../functions/icons";

export function ChatBottomBar({
  message,
  setMessage,
  files= [],
  setFiles,
  sendMessage,
}) {
  function handleFileSelect(event) {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      setFiles((prevFiles) => [...prevFiles, ...Array.from(selectedFiles)]);
    }
  }

  function removeFile(fileName) {
    setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  }
  return (
    <div
      className={`horizontal bottom-bar`}
      style={{ alignItems: files.length === 0 ? "center" : "end" }}
    >
      <input
        type="file"
        data-testid="file-upload-attachment"
        id="file-upload-attachment"
        style={{ display: "none" }}
        multiple
        onChange={handleFileSelect}
      />
      <IconButton
        onClick={() => document.getElementById("file-upload-attachment").click()}
        color={"standard-text-color"}
        icon2={"paperclip"}
        className={"small-standard-padding"}
      />
      <ChatInputField
        value={message}
        enterPressed={() => sendMessage()}
        inputChange={(t) => setMessage(t)}
        files={files}
        removeFile={removeFile}
      />
      <StandardButton
        isDisabled={false}
        className={"chatsend-button"}
        title={icon("send")}
        onClick={() => sendMessage()}
        style={{
          width: "42px",
          height: "42px",
          padding: "1rem 0.8rem",
        }}
      />
    </div>
  );
}
